export const giftProductIds = [
  '4487593001030',
  '4487618461766',
  '4487599652934',
  '4487628521542',
  '4487622361158',
  '4487620264006',
  '4487626096710',
  '4487627145286',
  '4487628259398',

  '4492555288646',
  '4492683575366',
  '4492634193990',
  '4492607225926',
  '4492649791558',
  '4492668371014',
  '4635339948078',
  '4635340013614',
  '4635340079150',
  '4538887962670',
  '4538879803438',
  '4538874101806',
  '4598131687470',
  '4538874200110',
  '4538878492718',
  '4538878394414',
];
